import { useLocation } from "react-router-dom";
import { getContainerClass } from "../../components/navigation/navigation";
import Cover from "../../components/cover/cover";
import CreateSlots from "../../components/createslots/createslots";

const CreateSlotsPage = () => {
  const breadcrumb = ["Home", "Facilities", "Create Slots"];
  const location = useLocation();

  return (
    <>
      <div className={getContainerClass(location.pathname)}>
        {/* <Header /> */}
        <Cover breadcrumb={breadcrumb} page="createSlots" />
        {/* <div className="slots-content"> */}
        <CreateSlots />
        {/* </div> */}
      </div>
    </>
  );
};

export default CreateSlotsPage;
